import React from "react";

interface RecommendedActionsSectionProps {
  actions: string[];
}

/**
 * Displays a numbered list of recommended actions.
 */
const RecommendedActionsSection: React.FC<RecommendedActionsSectionProps> = ({
  actions,
}) => (
  <div className="flex flex-col gap-3">
    <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#3D3D3D]">
      Recommended Actions
    </p>
    <div className="flex flex-col gap-2">
      {actions.map((action, idx) => (
        <div
          key={idx}
          className="flex items-center gap-3 rounded-[10px] border border-[#E6E6E6] bg-[#F7F9FA] px-3 py-3"
        >
          <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#D6D6D6] bg-white">
            <span className="text-[11px] font-bold text-[#3D3D3D]">
              {idx + 1}
            </span>
          </div>
          <p className="text-sm text-[#1F1F1F]">{action}</p>
        </div>
      ))}
    </div>
  </div>
);

export default RecommendedActionsSection;
